document.addEventListener("DOMContentLoaded", function () {
    const atc_buttons = document.querySelectorAll(".product-slider-atc-form .btn")

atc_buttons.forEach(btn => btn.addEventListener('click', function(e){
    e.preventDefault();
    var id = parseInt($(this).siblings(".atc-variant-id").val());
    var data = {
        'items': [{
            id: id,
            quantity: 1
        }]
    }
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      if (data.status === 422) {
        this.error(data);
      } else {
        var product = data;
        //this.success(product);
        
        if (window.matchMedia("(max-width: 769px)").matches){
            $('body').removeClass('no-scroll');
            window.scroll({
                top: Math.abs(bodyYoffset), 
            })
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    })
}) )
})


